import { render, staticRenderFns } from "./KahootWidget.vue?vue&type=template&id=08dbf929"
import script from "./KahootWidget.vue?vue&type=script&lang=js"
export * from "./KahootWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports